import React from 'react';

import { sortBy, splitEvery } from 'ramda';

import { Row, Col } from 'react-bootstrap';

import styled from 'styled-components';

import { colors } from 'z-react-components';

import { juniorHighSchoolSubjects, highSchoolSubjects } from '../../../constants/HighSchoolSubjects';

const SubjectsContainer = styled(Row)`
    display: flex;
    flex-wrap: wrap;

    @media (max-width: 1200px) {
        & > div {
            margin-top: 32px;
        }
    }
`;

const Title = styled.div`
    font-size: 40px;
    font-weight: bold;
    text-align: center;

    @media (max-width: 991px) {
        font-size: 32px;
    }
`;

const Subtitle = styled.div`
    font-size: 32px;
    font-weight: bold;
    text-align: center;

    @media (max-width: 991px) {
        font-size: 24px;
    }
`;

const BoxContainer = styled.div`
    padding: 16px;
    max-width: 1200px;
    margin: auto;
`;

const Box = styled.div`
    margin: 8px 0;
    padding: 16px;
    background: ${colors.grey100};
    height: 100%;
`;

const BoxTitle = styled.div`
    color: ${colors.orange};
    text-transform: uppercase;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
`;

const Subject = styled.div`
    padding: 8px 0;
    display: flex;
    align-items: center;
`;

const SubjectIcon = styled.img`
    height: 48px;
    width: 48px;
    margin-right: 16px;
`;

const SubjectName = styled.span`
    font-size: 20px;
`;

const Subjects = () => {
    const chunckSchoolSubjects = splitEvery(
        5,
        sortBy(subject => subject.subjectName, juniorHighSchoolSubjects)
    );
    const chunckHighSchoolSubjects = splitEvery(
        9,
        sortBy(subject => subject.subjectName, highSchoolSubjects)
    );

    return (
        <React.Fragment>
            <BoxContainer>
                <Title>{'Quali materie insegni?'}</Title>
                <Subtitle>{'Crea Verifiche è disponibile per le seguenti materie delle scuole medie superiori.'}</Subtitle>
                <SubjectsContainer>
                    <Col xs={12} lg={6}>
                        <Box>
                            <BoxTitle>{'Di primo grado'}</BoxTitle>
                            <Row>
                                {chunckSchoolSubjects.map((chunk, index) => (
                                    <Col xs={12} md={6} key={index}>
                                        {chunk.map((subject, index) => (
                                            <Subject key={index}>
                                                <SubjectIcon alt="subject_icon" src={subject.image} />
                                                <SubjectName>{subject.subjectName}</SubjectName>
                                            </Subject>
                                        ))}
                                    </Col>
                                ))}
                            </Row>
                        </Box>
                    </Col>
                    <Col xs={12} lg={6}>
                        <Box>
                            <BoxTitle>{'Di secondo grado'}</BoxTitle>
                            <Row>
                                {chunckHighSchoolSubjects.map((chunk, index) => (
                                    <Col xs={12} md={6} key={index}>
                                        {chunk.map((subject, index) => (
                                            <Subject key={index}>
                                                <SubjectIcon alt="subject_icon" src={subject.image} />
                                                <SubjectName>{subject.subjectName}</SubjectName>
                                            </Subject>
                                        ))}
                                    </Col>
                                ))}
                            </Row>
                        </Box>
                    </Col>
                </SubjectsContainer>
            </BoxContainer>
        </React.Fragment>
    );
};

export default Subjects;
